var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"minimalistic-readiness-level",class:{ disabled: _vm.disabled, [_setup.levelClass]: true }})
}
var staticRenderFns = []

export { render, staticRenderFns }